import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getProductsByCategory } from '../data/products';
import categories from '../data/categories';
import '../styles/CategoryPage.css';

const CategoryPage = () => {
  const { t } = useTranslation();
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    // Find the current category
    const currentCategory = categories.find(cat => cat.id === categoryId) || 
      { id: categoryId, nameKey: `cat_${categoryId}` };
    setCategory(currentCategory);

    // Get products for this category
    let categoryProducts = [];
    
    if (categoryId === 'tarot') {
      // 타로 카테고리에 대한 특별 상품 추가
      categoryProducts = [
        {
          id: 'tarot_love',
          titleKey: 'product_tarot_love_title',
          descriptionKey: 'product_love_desc',
          category: 'cat_tarot_love',
          originalPrice: 39000,
          discountRate: 49,
          finalPrice: 19900,
          reviews: 128,
          rating: 4.8
        },
        {
          id: 'tarot_future',
          titleKey: 'product_tarot_future_title',
          descriptionKey: 'product_career_desc',
          category: 'cat_tarot_future',
          originalPrice: 39000,
          discountRate: 49,
          finalPrice: 19900,
          reviews: 95,
          rating: 4.7
        },
        {
          id: 'tarot_career',
          titleKey: 'product_tarot_career_title',
          descriptionKey: 'product_career_desc',
          category: 'cat_tarot_career',
          originalPrice: 39000,
          discountRate: 49,
          finalPrice: 19900,
          reviews: 87,
          rating: 4.6
        }
      ];
    } else {
      // 기존 카테고리 상품 가져오기
      categoryProducts = getProductsByCategory(`cat_${categoryId}`);
    }
    
    setProducts(categoryProducts);
  }, [categoryId]);

  if (!category) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="category-page">
      <div className="category-header">
        <Link to="/" className="back-button">
          <span>←</span>
        </Link>
        <h1>{t(category.nameKey)}</h1>
      </div>

      <div className="product-list">
        {products.length > 0 ? (
          products.map(product => (
            <Link 
              to={`/product/${product.id}`} 
              className="product-card" 
              key={product.id}
            >
              <div className="product-image">
                <div className="placeholder-image" style={{ width: '100%', height: '100%', backgroundColor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
                  <span style={{ padding: '0.5rem', textAlign: 'center' }}>{t(product.titleKey).substring(0, 20)}</span>
                </div>
                <div className="tag">{t(product.category)}</div>
              </div>
              <div className="product-info">
                <p className="product-desc">{t(product.descriptionKey).substring(0, 80)}...</p>
                <div className="price">
                  <span className="original">
                    {new Intl.NumberFormat().format(product.originalPrice)}
                  </span>
                  <span className="discount">{product.discountRate}%</span>
                  <span className="final">
                    {new Intl.NumberFormat().format(product.finalPrice)}
                  </span>
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="no-products">
            <p>{t('no_products_found')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
